// customer 相关函数

import exp from "constants"

// 导出的字段选择
export const fnExportFields = (user_permission: any) => {
    let data = {
        all: [] as string[],//所有选项
        jian: [] as string[],//精简版选项
        quan: [] as string[],//全能版选项
    }
    // 超级管理员和代理商可以看所有字段
    if (['admin', 'seller'].includes(user_permission)) {
        data.all = ['主体名称', '统一社会信用代码', '法人代表姓名', '法人代表身份证号码', '注册地址', '合同开始时间', '合同结束时间', '主体类型', '入驻类型', '成立时间',
            '核准日期', '录入时间', '当前状态', '主体状态', '异常状态', '法人代表电话', '联络员姓名', '联络员电话', '工商预留手机号码', '紧急联系人电话', '其他电话', '是否支付',
            '归属代理商', '财务会计电话(续费联系人)', '财务公司名称', '财务公司对接人姓名', '财务公司对接人电话', '财务公司统一社会信用代码', '销售价格', '来年续费价格', '收费标准',
            '录单人', '税务状态', '税务状态更新时间', '社保人数', '年报情况', '投诉情况', '备注', '经营范围', '异常情况']
        data.jian = ['主体名称', '统一社会信用代码', '法人代表姓名', '注册地址', '合同开始时间', '合同结束时间', '主体类型', '入驻类型', '成立时间', '核准日期', '录入时间',
            '当前状态', '主体状态', '异常状态']
        data.quan = ['主体名称', '统一社会信用代码', '法人代表姓名', '法人代表身份证号码', '注册地址', '合同开始时间', '合同结束时间', '主体类型', '入驻类型', '成立时间',
            '核准日期', '录入时间', '当前状态', '主体状态', '异常状态', '法人代表电话', '联络员姓名', '联络员电话', '工商预留手机号码', '紧急联系人电话', '其他电话', '是否支付',
            '归属代理商', '财务会计电话(续费联系人)', '财务公司名称', '财务公司对接人姓名', '财务公司对接人电话', '财务公司统一社会信用代码', '销售价格', '来年续费价格', '收费标准',
            '录单人', '税务状态', '税务状态更新时间', '社保人数', '年报情况', '投诉情况', '备注', '经营范围', '异常情况']
    } else {
        //平台管理员或其他人排除财务公司和代理商等字段
        data.all = ['主体名称', '统一社会信用代码', '法人代表姓名', '法人代表身份证号码', '注册地址', '合同开始时间', '合同结束时间', '主体类型', '入驻类型', '成立时间',
            '核准日期', '录入时间', '当前状态', '主体状态', '异常状态', '法人代表电话', '工商预留手机号码', '紧急联系人电话', '其他电话', '是否支付',
            '销售价格', '来年续费价格', '收费标准',
            '税务状态', '税务状态更新时间', '社保人数', '年报情况', '投诉情况']
        data.jian = ['主体名称', '统一社会信用代码', '法人代表姓名', '注册地址', '合同开始时间', '合同结束时间', '主体类型', '入驻类型', '成立时间', '核准日期', '录入时间',
            '当前状态', '主体状态', '异常状态']
        data.quan = ['主体名称', '统一社会信用代码', '法人代表姓名', '法人代表身份证号码', '注册地址', '合同开始时间', '合同结束时间', '主体类型', '入驻类型', '成立时间',
            '核准日期', '录入时间', '当前状态', '主体状态', '异常状态', '法人代表电话', '工商预留手机号码', '紧急联系人电话', '其他电话', '是否支付',
            '销售价格', '来年续费价格', '收费标准',
            '税务状态', '税务状态更新时间', '社保人数', '年报情况', '投诉情况']
    }
    return data
}

/**
 * 经营范围字符串转成数组
 * @param str
 * @return type 0是经营范围，1前缀，2后缀
 */
export const businessScopeToArr = (businessScopeStr: string) => {
    //将英文的符号替换成中文
    let str = businessScopeStr.replace(/;/g, '；')
        .replace(/:/g, '：')
        .replace(/\(/g, '（')
        .replace(/\)/g, '）')
        .replace(/。/g, '；')
    let qianzui = [
        '一般项目',
        '许可项目',
    ]
    let houzui = [
        '（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）',
        '（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）',
        '（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以批准文件或许可证件为准）',
        '（除依法须经批准的项目外，自主开展法律法规未禁止、未限制的经营活动）'
    ]
    //前置的冒号替换成分号，为了切分
    str = str.replace(/：/g, '；')
    //遍历后缀，前后也补上分号，为了切分
    houzui.forEach(item => {
        str = str.replace(item, '；' + item + '；')
    })
    let arr = str.split('；')
    let list: { name: string; type: number }[] = []
    arr.forEach(item => {
        item = item.trim()
        if (item) {
            if (qianzui.includes(item)) {
                list.push({ name: item, type: 1 })
            } else if (houzui.includes(item)) {
                list.push({ name: item, type: 2 })
            } else {
                list.push({ name: item, type: 0 })
            }
        }
    })
    return list
}
//重新拼合起来
export const businessScopeToStr = (list: Array<{ name: string; type: number }>) => {
    let newStr = ''
    list.forEach(item => {
        if (item.type == 1) {
            newStr += item.name + '：'
        } else if (item.type == 2) {
            newStr += item.name
        } else {
            newStr += item.name + '；'
        }
    })
    return newStr
}

/**
 * 获取组织形式
 * 名称中的后缀
 */
export const getOrganizationalForm = (main_type, is_filiale, push_system) => {
    let list: any[] = []
    if (main_type == 1) {//公司
        if (is_filiale == 1) {
            list = ['分公司', '厂', '分厂', '经营部', '店', '商店', '分店', '分行', '支行', '营业部']
        } else {
            list = ['有限公司', '有限责任公司', '集团有限公司']
        }
    } else if (main_type == 2) {//个体
        if (push_system == 2) {//西安后缀
            list = ['店', '部', '馆', '食品店', '俱乐部', '行', '厂', '餐厅', '站', '招待所', '经销处']
        } else {
            list = ['经营部', '服务部', '商行', '店', '部', '工作室', '铺', '馆', '坊', '场', '门市部', '大药房', '药房', '药店', '厅', '行', '房', '社', '亭', '网咖',
                '网吧', '处', '厂', '咖啡厅', '咖啡店', '中心', '饭店', '饭堂', '吧', '商店', '商店馆', '浴池', '诊所', '门诊部', '俱乐部', '酒吧', '酒店', '旅店', '农家院',
                '农场', '影楼', '加盟店', '队', '超市', '家庭农场', '冷库', '餐厅', '苗圃', '医院', '屋', '广场', '城']
        }
    } else if (main_type == 3) {//个独
        if (is_filiale == 1) {
            list = ['分厂', '分店', '分所', '分部', '分中心']
        } else {
            if (push_system == 2) {//西安后缀
                list = ['店', '社', '厂', '部', '场', '吧', '所']
            } else {
                list = ["经营部", "部", "商行", "工作室", "店", "商店", "铺", "馆", "坊", "场", "门市部", "大药房", "药房", "药店", "厅", "行", "房", "社", "亭", "网咖",
                    "网吧", "处", "厂", "咖啡厅", "咖啡店", "中心", "饭店", "饭堂", "中心", "吧", "商店馆", "浴池", "诊所", "门诊部", "馆", "俱乐部", "酒吧", "酒店", "旅店",
                    "农家院", "农场", "影楼", "加盟店", "队", "超市", "家庭农场", "冷库", "餐厅", "苗圃", "医院", "屋", "广场", "站", '研究院']
            }
        }
    } else if (main_type == 4) {//合伙
        if (is_filiale == 1) {//有限合伙的分支机构
            list = ['厂', '分厂', '经营部', '店', '商店', '分店', '营业部', '工作室', '分部', '分中心']
        } else {
            list = ['合伙企业', '厂', '部', '店', '商行', '中心', '院', '所', '餐厅', '厅', '苗圃', '事务所', '广场', '处']
        }
    }
    return list
}
